import { Provider } from '@angular/core';
import { BREADCRUMB_TRACKER_PORT } from './breadcrumb-tracker.token';
import { BugsnagBreadcrumbTrackerService } from './bugsnag-breadcrumb-tracker.service';

export const BREADCRUMB_TRACKER_PROVIDER: Provider = {
    provide: BREADCRUMB_TRACKER_PORT,
    useExisting: BugsnagBreadcrumbTrackerService,
};
